import { memo } from "react";
import Screen, { type ScreenProps } from "ui/layouts/Screen";
import { IbanXS as IbanXSComponent } from "ui/organizms/OpenBanking";

const IbanXS = (props: ScreenProps) => (
    <Screen
        {...props}
        title='Open Banking | Iban XS'
    >
        <IbanXSComponent />
    </Screen>

);

export default memo(IbanXS);
